import React, { useEffect, useState } from 'react'
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import { EditPageHeader } from '../../components/EditPageHeader';
import BossDialog from '../../components/BossDialog';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import ToastNotification from '../../components/ToastNotification';

const GenreSubGenreMappingEditForm = (props) => {
    const lang = useTranslation();

    const blankDataItem = {
        ...props?.item,
        DVB_Content: props?.item?.copy ? "Copy of " + props?.item?.DVB_Content : props?.item?.DVB_Content ?? "",
        genre: props?.item?.genre ? {
            _id: props?.item?.genre?._id,
            SID: props?.item?.genre?.sid,
            Description: props?.item?.genre?.description,
            translatedDescription: props?.item?.genre?.translatedDescription
        } : {},
        subGenre: props?.item?.subGenre ? {
            _id: props?.item?.subGenre?._id,
            SID: props?.item?.subGenre?.sid,
            Description: props?.item?.subGenre?.description,
            translatedDescription: props?.item?.subGenre?.translatedDescription
        } : {},
        Archive: props?.item?.Archive ?? false,
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [genres, setGenres] = useState([]);

    useEffect(() => {
        loadCombo()
    }, [])

    const loadCombo = async () => {
        let genreRes = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
        setGenres(genreRes.data);
    }

    const onChange = (e) => {
        if (e.target.name === 'Archive') {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        }
        else { setDataItem({ ...dataItem, [e.target.name]: e.target.value }); }
    }

    const isValid = () => {

        if (!dataItem.genre || Object.keys(dataItem.genre).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_genre_error_message });
            return false;
        }
        if (!dataItem.subGenre || Object.keys(dataItem.subGenre).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_sub_genres_error_message });
            return false;
        }
        if (!dataItem.DVB_Content || dataItem.DVB_Content === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_dvb_content_error_message });
            return false;
        }
        return true;

    }

    const handleSubmit = async () => {
        if (!isValid()) return;
        const saveData = {
            _id: dataItem?._id,
            SID: dataItem?.SID,
            genre: dataItem?.genre && Object.keys(dataItem?.genre).length > 0 ? {
                _id: dataItem?.genre?._id,
                sid: dataItem?.genre?.SID,
                description: dataItem?.genre?.Description,
                translatedDescription: dataItem?.genre?.translatedDescription
            } : {},
            subGenre: dataItem?.subGenre && Object.keys(dataItem?.subGenre).length > 0 ? {
                _id: dataItem?.subGenre?._id,
                sid: dataItem?.subGenre?.SID,
                description: dataItem?.subGenre?.Description,
                translatedDescription: dataItem?.subGenre?.translatedDescription
            } : {},
            DVB_Content: dataItem?.DVB_Content,
            Archive: dataItem?.Archive ?? false
        }
        console.log(saveData);
        const res = await API.saveData(ENTITYNAME.GenreSubGenreMapping, saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.GENRE_SUBGENRE_MAPPING, data: res.data, message: res.message };
            API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.PGRating);
            props.cancelEdit();
            props.refresh();
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    return (
        <>
            <BossDialog
                title={props?.item?.genre?.description ?? lang.genre_subgenre_mapping_dialog_header}
                onClose={props.cancelEdit}
                width={"600px"}
            >
                <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />

                <div className='row mt-2'>
                    <div className='col-12'>
                        <div className='row mt-2'>
                            <div className="col-6">
                                <label>{lang.genre_label} *</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={genres}
                                    name="genre"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.genre}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="col-6">
                                <label>{lang.sub_genre_label} *</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={genres}
                                    name="subGenre"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.subGenre}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className='col-6'>
                                <label>{lang.dvb_content_label} *</label>
                                <input
                                    name="DVB_Content"
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={onChange}
                                    value={dataItem.DVB_Content}
                                />
                            </div>
                            <div className='col-2' style={{ marginTop: "25px" }}>
                                <input
                                    style={{ border: "1px solid grey" }}
                                    name={"Archive"}
                                    type='checkbox'
                                    onChange={onChange}
                                />
                                <label className="ml-2">{lang.archive}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </BossDialog >
        </>
    )
}

export default GenreSubGenreMappingEditForm
